export default "__VITE_ASSET__CHC2cXET__"